import { render, staticRenderFns } from "./anOrderPrice.vue?vue&type=template&id=4b03856e&scoped=true"
import script from "./anOrderPrice.vue?vue&type=script&lang=js"
export * from "./anOrderPrice.vue?vue&type=script&lang=js"
import style0 from "./anOrderPrice.vue?vue&type=style&index=0&id=4b03856e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03856e",
  null
  
)

export default component.exports